import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
};

export enum ActivateImLeavingResult {
  ImLeavingActivated = 'IM_LEAVING_ACTIVATED'
}

export type AddCheckOnMeContactInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum AddCheckOnMeContactResult {
  CannotAddSelf = 'CANNOT_ADD_SELF',
  ContactAdded = 'CONTACT_ADDED',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  Error = 'ERROR',
  MaxContactsReached = 'MAX_CONTACTS_REACHED',
  ResidentNotFound = 'RESIDENT_NOT_FOUND'
}

export type AddUserTokenInput = {
  fcmToken: Scalars['String']['input'];
};

export enum AddUserTokenResult {
  UserTokenAdded = 'USER_TOKEN_ADDED'
}

export enum AlarmoState {
  Armed = 'ARMED',
  Arming = 'ARMING',
  Disarmed = 'DISARMED'
}

export type Apartment = {
  __typename?: 'Apartment';
  activationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  alarmo?: Maybe<AlarmoState>;
  bathroomA?: Maybe<Bathroom>;
  bedroomA?: Maybe<Bedroom>;
  canDecreaseTemperature?: Maybe<Scalars['Boolean']['output']>;
  canIncreaseTemperature?: Maybe<Scalars['Boolean']['output']>;
  customLightColor01?: Maybe<Scalars['String']['output']>;
  customLightColor02?: Maybe<Scalars['String']['output']>;
  customLightColor03?: Maybe<Scalars['String']['output']>;
  customLightColor04?: Maybe<Scalars['String']['output']>;
  hallwayA?: Maybe<Hallway>;
  imLeavingAlarmOn?: Maybe<OnOff>;
  imLeavingHVACOff?: Maybe<OnOff>;
  imLeavingLightsOff?: Maybe<OnOff>;
  kitchenA?: Maybe<Kitchen>;
  lightBrightnessMax?: Maybe<Scalars['Int']['output']>;
  lightBrightnessMin?: Maybe<Scalars['Int']['output']>;
  lightTemperatureMax?: Maybe<Scalars['Int']['output']>;
  lightTemperatureMin?: Maybe<Scalars['Int']['output']>;
  livingspaceA?: Maybe<LivingSpace>;
  openWindowAlert?: Maybe<OnOff>;
  sanitization?: Maybe<SanitizationState>;
  vacationMode?: Maybe<OnOff>;
};

export type ApartmentChangeAlarmoStateValue = {
  __typename?: 'ApartmentChangeAlarmoStateValue';
  alarmoStateValue?: Maybe<AlarmoState>;
  path: Scalars['String']['output'];
};

export type ApartmentChangeBooleanValue = {
  __typename?: 'ApartmentChangeBooleanValue';
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  path: Scalars['String']['output'];
};

export type ApartmentChangeClimateStateValue = {
  __typename?: 'ApartmentChangeClimateStateValue';
  climateStateValue?: Maybe<ClimateState>;
  path: Scalars['String']['output'];
};

export type ApartmentChangeIntValue = {
  __typename?: 'ApartmentChangeIntValue';
  intValue?: Maybe<Scalars['Int']['output']>;
  path: Scalars['String']['output'];
};

export type ApartmentChangeOnOffValue = {
  __typename?: 'ApartmentChangeOnOffValue';
  onOffValue?: Maybe<OnOff>;
  path: Scalars['String']['output'];
};

export type ApartmentChangeSanitizationStateValue = {
  __typename?: 'ApartmentChangeSanitizationStateValue';
  path: Scalars['String']['output'];
  sanitizationStateValue?: Maybe<SanitizationState>;
};

export type ApartmentChangeSet = {
  __typename?: 'ApartmentChangeSet';
  changes: Array<ApartmentChangeValue>;
};

export type ApartmentChangeStringValue = {
  __typename?: 'ApartmentChangeStringValue';
  path: Scalars['String']['output'];
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type ApartmentChangeValue = ApartmentChangeAlarmoStateValue | ApartmentChangeBooleanValue | ApartmentChangeClimateStateValue | ApartmentChangeIntValue | ApartmentChangeOnOffValue | ApartmentChangeSanitizationStateValue | ApartmentChangeStringValue;

export type AppSetting = {
  __typename?: 'AppSetting';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ArmAlarmoResult {
  AlarmoArmed = 'ALARMO_ARMED'
}

export type Bathroom = {
  __typename?: 'Bathroom';
  lighting?: Maybe<Lighting>;
  showerAlert?: Maybe<OnOff>;
  showerAlertTime?: Maybe<Scalars['Int']['output']>;
  showerFanAutoOn?: Maybe<OnOff>;
};

export type Bedroom = {
  __typename?: 'Bedroom';
  climate?: Maybe<Climate>;
  lighting?: Maybe<Lighting>;
};

export type Building = {
  __typename?: 'Building';
  address?: Maybe<Scalars['String']['output']>;
  buildingCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  propertyManagerCompany?: Maybe<Scalars['String']['output']>;
  propertyManagerEmail?: Maybe<Scalars['String']['output']>;
  propertyManagerPhone?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Unit>;
};

export type CheckOnMeContact = {
  __typename?: 'CheckOnMeContact';
  confirmedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: CheckOnMeContactStatus;
};

export enum CheckOnMeContactStatus {
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING',
  Removed = 'REMOVED'
}

export type Climate = {
  __typename?: 'Climate';
  autoSet?: Maybe<OnOff>;
  currentTemperature?: Maybe<Scalars['Int']['output']>;
  ecoMode?: Maybe<OnOff>;
  sleepTemperature?: Maybe<Scalars['Int']['output']>;
  sleepTemperatureAttributes?: Maybe<TemperatureAttributes>;
  sleepTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ClimateState>;
  targetTemperatureHigh?: Maybe<Scalars['Int']['output']>;
  targetTemperatureLow?: Maybe<Scalars['Int']['output']>;
  temperature?: Maybe<Scalars['Int']['output']>;
  wakeTemperature?: Maybe<Scalars['Int']['output']>;
  wakeTemperatureAttributes?: Maybe<TemperatureAttributes>;
  wakeTime?: Maybe<Scalars['String']['output']>;
};

export enum ClimateState {
  Cool = 'COOL',
  Heat = 'HEAT',
  HeatCool = 'HEAT_COOL',
  Off = 'OFF'
}

export type CreateSurveyResponseInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  numericValue?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
};

export enum CreateSurveyResponseResult {
  SurveyResponseCreated = 'SURVEY_RESPONSE_CREATED'
}

export enum CustomLightColorName {
  CustomLightColor_01 = 'CUSTOM_LIGHT_COLOR_01',
  CustomLightColor_02 = 'CUSTOM_LIGHT_COLOR_02',
  CustomLightColor_03 = 'CUSTOM_LIGHT_COLOR_03',
  CustomLightColor_04 = 'CUSTOM_LIGHT_COLOR_04'
}

export type DecreaseTemperatureInput = {
  roomNames: Array<RoomName>;
};

export enum DecreaseTemperatureResult {
  TemperatureDecreased = 'TEMPERATURE_DECREASED'
}

export enum DefaultSettingsGroup {
  Climate = 'CLIMATE',
  Lighting = 'LIGHTING',
  Notifications = 'NOTIFICATIONS',
  Shower = 'SHOWER'
}

export enum DisarmAlarmoResult {
  AlarmoDisarmed = 'ALARMO_DISARMED'
}

export type DismissSurveyInput = {
  surveyId: Scalars['String']['input'];
};

export enum DismissSurveyResult {
  SurveyDismissed = 'SURVEY_DISMISSED'
}

export type EditCheckOnMeContactInput = {
  contactId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum EditCheckOnMeContactResult {
  CannotAddSelf = 'CANNOT_ADD_SELF',
  ContactNotFound = 'CONTACT_NOT_FOUND',
  ContactUpdated = 'CONTACT_UPDATED',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  Error = 'ERROR'
}

export type ExperimentalFeature = {
  __typename?: 'ExperimentalFeature';
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type FilterInput = {
  importance?: InputMaybe<NotificationImportance>;
  status?: InputMaybe<NotificationStatus>;
};

export enum HrvName {
  HrvA = 'HRV_A'
}

export type Hallway = {
  __typename?: 'Hallway';
  lighting?: Maybe<Lighting>;
};

export type HomeAssistantEvent = {
  __typename?: 'HomeAssistantEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  event: Scalars['String']['output'];
  internalIp: Scalars['String']['output'];
};

export type IncreaseTemperatureInput = {
  roomNames: Array<RoomName>;
};

export enum IncreaseTemperatureResult {
  TemperatureIncreased = 'TEMPERATURE_INCREASED'
}

export type Kitchen = {
  __typename?: 'Kitchen';
  lighting?: Maybe<Lighting>;
};

export enum LightName {
  LightA = 'LIGHT_A',
  LightB = 'LIGHT_B'
}

export type Lighting = {
  __typename?: 'Lighting';
  lightsAutoOff?: Maybe<OnOff>;
  lightsAutoOffTime?: Maybe<Scalars['Int']['output']>;
  lightsAutoOn?: Maybe<OnOff>;
  lightsBrightness?: Maybe<Scalars['Int']['output']>;
  lightsCircadian?: Maybe<OnOff>;
  lightsColor?: Maybe<Scalars['String']['output']>;
  lightsTemperature?: Maybe<Scalars['Int']['output']>;
  nightLight?: Maybe<OnOff>;
  state?: Maybe<OnOff>;
};

export type LivingSpace = {
  __typename?: 'LivingSpace';
  climate?: Maybe<Climate>;
  lighting?: Maybe<Lighting>;
  mediaPlayerBluetoothEnabled?: Maybe<OnOff>;
};

export enum MediaPlayerSource {
  Bluetooth = 'BLUETOOTH',
  RadioTuner = 'RADIO_TUNER'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateImLeaving: ActivateImLeavingResult;
  addCheckOnMeContact: AddCheckOnMeContactResult;
  addUserToken: AddUserTokenResult;
  armAlarmo: ArmAlarmoResult;
  createSurveyResponse: CreateSurveyResponseResult;
  decreaseTemperature: DecreaseTemperatureResult;
  disarmAlarmo: DisarmAlarmoResult;
  dismissSurvey: DismissSurveyResult;
  editCheckOnMeContact: EditCheckOnMeContactResult;
  increaseTemperature: IncreaseTemperatureResult;
  remindUserApplicationPin: RemindUserApplicationPinResult;
  removeCheckOnMeContact: RemoveCheckOnMeContactResult;
  removeUserApartmentPin: RemoveUserAppartmentPinResult;
  resendCheckOnMeContactConfirmation: ResendCheckOnMeContactConfirmationResult;
  restoreDefaultSettings: RestoreDefaultSettingsResult;
  selectMediaPlayerSource: SelectMediaPlayerSourceResult;
  setCustomLightColor: SetCustomLightColorResult;
  setEcoMode: SetEcoModeResult;
  setImLeavingAlarmOn: SetImLeavingAlarmOnResult;
  setImLeavingHVACOff: SetImLeavingHvacOffResult;
  setImLeavingLightsOff: SetImLeavingLightsOffResult;
  setLightsAutoOff: SetLightsAutoOffResult;
  setLightsAutoOffTime: SetLightsAutoOffTimeResult;
  setLightsAutoOn: SetLightsAutoOnResult;
  setLightsBrightness: SetLightsBrightnessResult;
  setLightsCircadian: SetLightsCircadianResult;
  setLightsColor: SetLightsColorResult;
  setLightsTemperature: SetLightsTemperatureResult;
  setNightLight: SetNightLightResult;
  setOpenWindowAlert: SetOpenWindowAlertResult;
  setShowerAlert: SetShowerAlertResult;
  setShowerAlertTime: SetShowerAlertTimeResult;
  setShowerFanAutoOn: SetShowerFanAutoOnResult;
  setSleepTemperature: SetSleepTemperatureResult;
  setSleepTime: SetSleepTimeResult;
  setUserApartmentPin: SetUserApartmentPinResult;
  setVacationMode: SetVacationModeResult;
  setWakeTemperature: SetWakeTemperatureResult;
  setWakeTime: SetWakeTimeResult;
  startSanitization: StartSanitizationResult;
  submitEarlyAccessFeedback: SubmitEarlyAccessFeedbackResult;
  turnClimateOff: TurnClimateOffResult;
  turnClimateOn: TurnClimateOnResult;
  turnHRVOff: TurnHrvOffResult;
  turnHRVOn: TurnHrvOnResult;
  turnLightOff: TurnLightOffResult;
  turnLightOn: TurnLightOnResult;
  turnLightsAllOff: TurnLightsAllOffResult;
  turnLightsAllOn: TurnLightsAllOnResult;
  updateAllNotifications: UpdateAllNotificationsResult;
  updateBuildingSettings: UpdateBuildingSettingsResult;
  updateNotification: UpdateNotificationResult;
  updateResidentSettings: UpdateResidentSettingsResult;
  updateSurveyResponse: UpdateSurveyResponseResult;
  updateUnitSettings: UpdateUnitSettingsResult;
  updateUserLastLogin: UpdateUserSettingsResult;
  updateUserSettings: UpdateUserSettingsResult;
  viewSurvey: ViewSurveyResult;
};


export type MutationAddCheckOnMeContactArgs = {
  input: AddCheckOnMeContactInput;
};


export type MutationAddUserTokenArgs = {
  input: AddUserTokenInput;
};


export type MutationCreateSurveyResponseArgs = {
  input: CreateSurveyResponseInput;
};


export type MutationDecreaseTemperatureArgs = {
  input: DecreaseTemperatureInput;
};


export type MutationDismissSurveyArgs = {
  input: DismissSurveyInput;
};


export type MutationEditCheckOnMeContactArgs = {
  input: EditCheckOnMeContactInput;
};


export type MutationIncreaseTemperatureArgs = {
  input: IncreaseTemperatureInput;
};


export type MutationRemoveCheckOnMeContactArgs = {
  contactId: Scalars['String']['input'];
};


export type MutationResendCheckOnMeContactConfirmationArgs = {
  contactId: Scalars['String']['input'];
};


export type MutationRestoreDefaultSettingsArgs = {
  input: RestoreDefaultSettingsInput;
};


export type MutationSelectMediaPlayerSourceArgs = {
  input: SelectMediaPlayerSourceInput;
};


export type MutationSetCustomLightColorArgs = {
  input: SetCustomLightColorInput;
};


export type MutationSetEcoModeArgs = {
  input: SetEcoModeInput;
};


export type MutationSetImLeavingAlarmOnArgs = {
  input: SetImLeavingAlarmOnInput;
};


export type MutationSetImLeavingHvacOffArgs = {
  input: SetImLeavingHvacOffInput;
};


export type MutationSetImLeavingLightsOffArgs = {
  input: SetImLeavingLightsOffInput;
};


export type MutationSetLightsAutoOffArgs = {
  input: SetLightsAutoOffInput;
};


export type MutationSetLightsAutoOffTimeArgs = {
  input: SetLightsAutoOffTimeInput;
};


export type MutationSetLightsAutoOnArgs = {
  input: SetLightsAutoOnInput;
};


export type MutationSetLightsBrightnessArgs = {
  input: SetLightsBrightnessInput;
};


export type MutationSetLightsCircadianArgs = {
  input: SetLightsCircadianInput;
};


export type MutationSetLightsColorArgs = {
  input: SetLightsColorInput;
};


export type MutationSetLightsTemperatureArgs = {
  input: SetLightsTemperatureInput;
};


export type MutationSetNightLightArgs = {
  input: SetNightLightInput;
};


export type MutationSetOpenWindowAlertArgs = {
  input: SetOpenWindowAlertInput;
};


export type MutationSetShowerAlertArgs = {
  input: SetShowerAlertInput;
};


export type MutationSetShowerAlertTimeArgs = {
  input: SetShowerAlertTimeInput;
};


export type MutationSetShowerFanAutoOnArgs = {
  input: SetShowerFanAutoOnInput;
};


export type MutationSetSleepTemperatureArgs = {
  input: SetSleepTemperatureInput;
};


export type MutationSetSleepTimeArgs = {
  input: SetSleepTimeInput;
};


export type MutationSetUserApartmentPinArgs = {
  input: SetUserApartmentPinInput;
};


export type MutationSetVacationModeArgs = {
  input: SetVacationModeInput;
};


export type MutationSetWakeTemperatureArgs = {
  input: SetWakeTemperatureInput;
};


export type MutationSetWakeTimeArgs = {
  input: SetWakeTimeInput;
};


export type MutationSubmitEarlyAccessFeedbackArgs = {
  input: SubmitEarlyAccessFeedbackInput;
};


export type MutationTurnClimateOffArgs = {
  input: TurnClimateOffInput;
};


export type MutationTurnClimateOnArgs = {
  input: TurnClimateOnInput;
};


export type MutationTurnHrvOffArgs = {
  input: TurnHrvOffInput;
};


export type MutationTurnHrvOnArgs = {
  input: TurnHrvOnInput;
};


export type MutationTurnLightOffArgs = {
  input: TurnLightOffInput;
};


export type MutationTurnLightOnArgs = {
  input: TurnLightOnInput;
};


export type MutationUpdateAllNotificationsArgs = {
  input: UpdateAllNotificationsInput;
};


export type MutationUpdateBuildingSettingsArgs = {
  input: UpdateBuildingSettingsInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateResidentSettingsArgs = {
  input: UpdateResidentSettingsInput;
};


export type MutationUpdateSurveyResponseArgs = {
  input: UpdateSurveyResponseInput;
};


export type MutationUpdateUnitSettingsArgs = {
  input: UpdateUnitSettingsInput;
};


export type MutationUpdateUserLastLoginArgs = {
  input: UpdateUserLastLoginInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};


export type MutationViewSurveyArgs = {
  input: ViewSurveyInput;
};

export type NearestScheduledMoveIn = {
  __typename?: 'NearestScheduledMoveIn';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type NearestScheduledMoveOut = {
  __typename?: 'NearestScheduledMoveOut';
  date?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTimeISO']['output'];
  homeAssistantEventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importance: NotificationImportance;
  status: NotificationStatus;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum NotificationChannel {
  Email = 'EMAIL',
  Flash = 'FLASH',
  Push = 'PUSH',
  Siren = 'SIREN',
  Sms = 'SMS'
}

export enum NotificationImportance {
  Critical = 'CRITICAL',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  criticalLevelNotificationChannels: Array<NotificationChannel>;
  energyConsumptionNotifications: Scalars['Boolean']['output'];
  lowLevelNotificationChannels: Array<NotificationChannel>;
  mediumLevelNotificationChannels: Array<NotificationChannel>;
  muteNotifications: Scalars['Boolean']['output'];
  severeWeatherNotifications: Scalars['Boolean']['output'];
};

export type NotificationSettingsInput = {
  criticalLevelNotificationChannels?: InputMaybe<Array<NotificationChannel>>;
  energyConsumptionNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  lowLevelNotificationChannels?: InputMaybe<Array<NotificationChannel>>;
  mediumLevelNotificationChannels?: InputMaybe<Array<NotificationChannel>>;
  muteNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  severeWeatherNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NotificationStatus {
  NotRead = 'NOT_READ',
  Read = 'READ'
}

export enum OnOff {
  Off = 'OFF',
  On = 'ON'
}

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  apartment?: Maybe<Apartment>;
  apartmentChangeSet?: Maybe<ApartmentChangeSet>;
  appSettings?: Maybe<Array<AppSetting>>;
  getActiveSurveys?: Maybe<Array<Survey>>;
  getBuilding?: Maybe<Building>;
  getBuildingSettings?: Maybe<Scalars['String']['output']>;
  getCheckOnMeContacts: Array<CheckOnMeContact>;
  getExperimentalFeatures?: Maybe<Array<ExperimentalFeature>>;
  getResidentSettings?: Maybe<Scalars['String']['output']>;
  getSurveyResponses?: Maybe<Array<SurveyInteraction>>;
  getUnitSettings?: Maybe<Scalars['String']['output']>;
  getUserBuilding?: Maybe<Building>;
  homeAssistantEvents?: Maybe<Array<HomeAssistantEvent>>;
  nearestScheduledMoveIn?: Maybe<NearestScheduledMoveIn>;
  nearestScheduledMoveOut?: Maybe<NearestScheduledMoveOut>;
  notifications?: Maybe<Array<Notification>>;
  userSettings: UserSettings;
};


export type QueryGetBuildingArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSurveyResponsesArgs = {
  surveyId: Scalars['String']['input'];
};


export type QueryHomeAssistantEventsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<FilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type RgbColorInput = {
  b: Scalars['Int']['input'];
  g: Scalars['Int']['input'];
  r: Scalars['Int']['input'];
};

export enum RemindUserApplicationPinResult {
  UserApplicationPinSentToEmail = 'USER_APPLICATION_PIN_SENT_TO_EMAIL'
}

export enum RemoveCheckOnMeContactResult {
  ContactNotFound = 'CONTACT_NOT_FOUND',
  ContactRemoved = 'CONTACT_REMOVED'
}

export enum RemoveUserAppartmentPinResult {
  UserAppartmentPinRemoved = 'USER_APPARTMENT_PIN_REMOVED'
}

export enum ResendCheckOnMeContactConfirmationResult {
  AlreadyConfirmed = 'ALREADY_CONFIRMED',
  ConfirmationResent = 'CONFIRMATION_RESENT',
  ContactNotFound = 'CONTACT_NOT_FOUND',
  Error = 'ERROR'
}

export type RestoreDefaultSettingsInput = {
  defaultSettingsGroup: DefaultSettingsGroup;
  roomName?: InputMaybe<RoomName>;
};

export enum RestoreDefaultSettingsResult {
  DefaultSettingsRestored = 'DEFAULT_SETTINGS_RESTORED'
}

export enum RoomName {
  BathroomA = 'BATHROOM_A',
  BedroomA = 'BEDROOM_A',
  HallwayA = 'HALLWAY_A',
  KitchenA = 'KITCHEN_A',
  LivingspaceA = 'LIVINGSPACE_A'
}

export enum SanitizationState {
  Active = 'ACTIVE',
  Idle = 'IDLE'
}

export type SelectMediaPlayerSourceInput = {
  source: MediaPlayerSource;
};

export enum SelectMediaPlayerSourceResult {
  MediaPlayerSourceSelected = 'MEDIA_PLAYER_SOURCE_SELECTED'
}

export type SetCustomLightColorInput = {
  customLightColorName: CustomLightColorName;
  value: Scalars['String']['input'];
};

export enum SetCustomLightColorResult {
  CustomLightColorSet = 'CUSTOM_LIGHT_COLOR_SET'
}

export type SetEcoModeInput = {
  roomName: RoomName;
  value: OnOff;
};

export enum SetEcoModeResult {
  EcoModeSet = 'ECO_MODE_SET'
}

export type SetImLeavingAlarmOnInput = {
  value: OnOff;
};

export enum SetImLeavingAlarmOnResult {
  ImLeavingAlarmOnSet = 'IM_LEAVING_ALARM_ON_SET'
}

export type SetImLeavingHvacOffInput = {
  value: OnOff;
};

export enum SetImLeavingHvacOffResult {
  ImLeavingHvacOffSet = 'IM_LEAVING_HVAC_OFF_SET'
}

export type SetImLeavingLightsOffInput = {
  value: OnOff;
};

export enum SetImLeavingLightsOffResult {
  ImLeavingLightsOffSet = 'IM_LEAVING_LIGHTS_OFF_SET'
}

export type SetLightsAutoOffInput = {
  roomName: RoomName;
  value: OnOff;
};

export enum SetLightsAutoOffResult {
  LightsAutoOffSet = 'LIGHTS_AUTO_OFF_SET'
}

export type SetLightsAutoOffTimeInput = {
  roomName: RoomName;
  value: Scalars['Int']['input'];
};

export enum SetLightsAutoOffTimeResult {
  LightsAutoOffTimeSet = 'LIGHTS_AUTO_OFF_TIME_SET'
}

export type SetLightsAutoOnInput = {
  roomName: RoomName;
  value: OnOff;
};

export enum SetLightsAutoOnResult {
  LightsAutoOnSet = 'LIGHTS_AUTO_ON_SET'
}

export type SetLightsBrightnessInput = {
  roomName: RoomName;
  value: Scalars['Int']['input'];
};

export enum SetLightsBrightnessResult {
  LightsBrightnessSet = 'LIGHTS_BRIGHTNESS_SET'
}

export type SetLightsCircadianInput = {
  roomName: RoomName;
  value: OnOff;
};

export enum SetLightsCircadianResult {
  LightsCircadianSet = 'LIGHTS_CIRCADIAN_SET'
}

export type SetLightsColorInput = {
  roomName: RoomName;
  value: Scalars['String']['input'];
};

export enum SetLightsColorResult {
  LightsColorSet = 'LIGHTS_COLOR_SET'
}

export type SetLightsTemperatureInput = {
  roomName: RoomName;
  value: Scalars['Int']['input'];
};

export enum SetLightsTemperatureResult {
  LightsTemperatureSet = 'LIGHTS_TEMPERATURE_SET'
}

export type SetNightLightInput = {
  roomName: RoomName;
  value: OnOff;
};

export enum SetNightLightResult {
  NightLightSet = 'NIGHT_LIGHT_SET'
}

export type SetOpenWindowAlertInput = {
  value: OnOff;
};

export enum SetOpenWindowAlertResult {
  OpenWindowAlertSet = 'OPEN_WINDOW_ALERT_SET'
}

export type SetShowerAlertInput = {
  roomName: RoomName;
  value: OnOff;
};

export enum SetShowerAlertResult {
  ShowerAlertSet = 'SHOWER_ALERT_SET'
}

export type SetShowerAlertTimeInput = {
  roomName: RoomName;
  value: Scalars['Int']['input'];
};

export enum SetShowerAlertTimeResult {
  ShowerAlertTimeSet = 'SHOWER_ALERT_TIME_SET'
}

export type SetShowerFanAutoOnInput = {
  roomName: RoomName;
  value: OnOff;
};

export enum SetShowerFanAutoOnResult {
  ShowerFanAutoOnSet = 'SHOWER_FAN_AUTO_ON_SET'
}

export type SetSleepTemperatureInput = {
  roomName: RoomName;
  value: Scalars['Int']['input'];
};

export enum SetSleepTemperatureResult {
  SleepTemperatureSet = 'SLEEP_TEMPERATURE_SET'
}

export type SetSleepTimeInput = {
  roomName: RoomName;
  value: Scalars['String']['input'];
};

export enum SetSleepTimeResult {
  SleepTimeSet = 'SLEEP_TIME_SET'
}

export type SetUserApartmentPinInput = {
  pin: Scalars['String']['input'];
};

export enum SetUserApartmentPinResult {
  UserApartmentPinSet = 'USER_APARTMENT_PIN_SET'
}

export type SetVacationModeInput = {
  value: OnOff;
};

export enum SetVacationModeResult {
  VacationModeSet = 'VACATION_MODE_SET'
}

export type SetWakeTemperatureInput = {
  roomName: RoomName;
  value: Scalars['Int']['input'];
};

export enum SetWakeTemperatureResult {
  WakeTemperatureSet = 'WAKE_TEMPERATURE_SET'
}

export type SetWakeTimeInput = {
  roomName: RoomName;
  value: Scalars['String']['input'];
};

export enum SetWakeTimeResult {
  WakeTimeSet = 'WAKE_TIME_SET'
}

export enum StartSanitizationResult {
  SanitizationStarted = 'SANITIZATION_STARTED'
}

export type SubmitEarlyAccessFeedbackInput = {
  appVersion: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
  feedback: Scalars['String']['input'];
  platform: Scalars['String']['input'];
};

export enum SubmitEarlyAccessFeedbackResult {
  Error = 'ERROR',
  FeedbackSubmitted = 'FEEDBACK_SUBMITTED'
}

export type Subscription = {
  __typename?: 'Subscription';
  apartmentChanged: ApartmentChangeSet;
  notificationCreated: Notification;
};

export type Survey = {
  __typename?: 'Survey';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<Array<SurveyQuestion>>;
  startDate?: Maybe<Scalars['String']['output']>;
  targetBuildingIds?: Maybe<Array<Scalars['String']['output']>>;
  targetFloors?: Maybe<Scalars['String']['output']>;
  targetUserIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type SurveyInteraction = {
  __typename?: 'SurveyInteraction';
  answer?: Maybe<Scalars['String']['output']>;
  apartmentName?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  numericValue?: Maybe<Scalars['Int']['output']>;
  questionId?: Maybe<Scalars['String']['output']>;
  surveyId: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  type: SurveyInteractionType;
  userId: Scalars['String']['output'];
};

export enum SurveyInteractionType {
  Dismissed = 'DISMISSED',
  Responded = 'RESPONDED',
  Viewed = 'VIEWED'
}

export type SurveyQuestion = {
  __typename?: 'SurveyQuestion';
  id: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  order: Scalars['Int']['output'];
  prompt: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  surveyId: Scalars['String']['output'];
  type: SurveyQuestionType;
};

export enum SurveyQuestionType {
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  Rating = 'RATING',
  Text = 'TEXT',
  Thumbs = 'THUMBS'
}

export type TemperatureAttributes = {
  __typename?: 'TemperatureAttributes';
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
};

export type TurnClimateOffInput = {
  roomName: RoomName;
};

export enum TurnClimateOffResult {
  ClimateTurnedOff = 'CLIMATE_TURNED_OFF'
}

export type TurnClimateOnInput = {
  roomName: RoomName;
};

export enum TurnClimateOnResult {
  ClimateTurnedOn = 'CLIMATE_TURNED_ON'
}

export type TurnHrvOffInput = {
  hrvName: HrvName;
};

export enum TurnHrvOffResult {
  HrvTurnedOff = 'HRV_TURNED_OFF'
}

export type TurnHrvOnInput = {
  hrvName: HrvName;
};

export enum TurnHrvOnResult {
  HrvTurnedOn = 'HRV_TURNED_ON'
}

export type TurnLightOffInput = {
  lightName?: InputMaybe<LightName>;
  roomName: RoomName;
};

export enum TurnLightOffResult {
  LightTurnedOff = 'LIGHT_TURNED_OFF'
}

export type TurnLightOnInput = {
  brightness?: InputMaybe<Scalars['Int']['input']>;
  kelvin?: InputMaybe<Scalars['Int']['input']>;
  lightName?: InputMaybe<LightName>;
  rgbColor?: InputMaybe<RgbColorInput>;
  roomName: RoomName;
};

export enum TurnLightOnResult {
  LightTurnedOn = 'LIGHT_TURNED_ON'
}

export enum TurnLightsAllOffResult {
  LightsAllTurnedOff = 'LIGHTS_ALL_TURNED_OFF'
}

export enum TurnLightsAllOnResult {
  LightsAllTurnedOn = 'LIGHTS_ALL_TURNED_ON'
}

export type Unit = {
  __typename?: 'Unit';
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  floor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type UpdateAllNotificationsInput = {
  status: NotificationStatus;
};

export enum UpdateAllNotificationsResult {
  AllNotificationsUpdated = 'ALL_NOTIFICATIONS_UPDATED'
}

export type UpdateBuildingSettingsInput = {
  buildingId: Scalars['String']['input'];
  settings: Scalars['String']['input'];
};

export enum UpdateBuildingSettingsResult {
  BuildingNotFound = 'BUILDING_NOT_FOUND',
  BuildingSettingsUpdated = 'BUILDING_SETTINGS_UPDATED'
}

export type UpdateNotificationInput = {
  id: Scalars['String']['input'];
  status: NotificationStatus;
};

export enum UpdateNotificationResult {
  NotificationNotUpdated = 'NOTIFICATION_NOT_UPDATED',
  NotificationUpdated = 'NOTIFICATION_UPDATED'
}

export type UpdateResidentSettingsInput = {
  settings: Scalars['String']['input'];
};

export enum UpdateResidentSettingsResult {
  ResidentNotFound = 'RESIDENT_NOT_FOUND',
  ResidentSettingsUpdated = 'RESIDENT_SETTINGS_UPDATED'
}

export type UpdateSurveyResponseInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  interactionId: Scalars['String']['input'];
  numericValue?: InputMaybe<Scalars['Int']['input']>;
};

export enum UpdateSurveyResponseResult {
  SurveyResponseNotFound = 'SURVEY_RESPONSE_NOT_FOUND',
  SurveyResponseUpdated = 'SURVEY_RESPONSE_UPDATED'
}

export type UpdateUnitSettingsInput = {
  settings: Scalars['String']['input'];
  unitId: Scalars['String']['input'];
};

export enum UpdateUnitSettingsResult {
  UnitNotFound = 'UNIT_NOT_FOUND',
  UnitSettingsUpdated = 'UNIT_SETTINGS_UPDATED'
}

export type UpdateUserLastLoginInput = {
  ClientAppVersion?: InputMaybe<Scalars['String']['input']>;
  OsDisplay?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserSettingsInput = {
  checkOnMeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<NotificationSettingsInput>;
  syncClimate?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UpdateUserSettingsResult {
  UserSettingsUpdated = 'USER_SETTINGS_UPDATED',
  UserSettingsValidationFailed = 'USER_SETTINGS_VALIDATION_FAILED'
}

export type UserSettings = {
  __typename?: 'UserSettings';
  checkOnMeEnabled: Scalars['Boolean']['output'];
  notificationSettings: NotificationSettings;
  syncClimate: Scalars['Boolean']['output'];
};

export type ViewSurveyInput = {
  surveyId: Scalars['String']['input'];
};

export enum ViewSurveyResult {
  SurveyViewed = 'SURVEY_VIEWED'
}

export type SubmitEarlyAccessFeedbackMutationVariables = Exact<{
  input: SubmitEarlyAccessFeedbackInput;
}>;


export type SubmitEarlyAccessFeedbackMutation = { __typename?: 'Mutation', submitEarlyAccessFeedback: SubmitEarlyAccessFeedbackResult };

export type UpdateBuildingSettingsMutationVariables = Exact<{
  input: UpdateBuildingSettingsInput;
}>;


export type UpdateBuildingSettingsMutation = { __typename?: 'Mutation', updateBuildingSettings: UpdateBuildingSettingsResult };

export type UpdateUnitSettingsMutationVariables = Exact<{
  input: UpdateUnitSettingsInput;
}>;


export type UpdateUnitSettingsMutation = { __typename?: 'Mutation', updateUnitSettings: UpdateUnitSettingsResult };

export type UpdateResidentSettingsMutationVariables = Exact<{
  input: UpdateResidentSettingsInput;
}>;


export type UpdateResidentSettingsMutation = { __typename?: 'Mutation', updateResidentSettings: UpdateResidentSettingsResult };

export type AppSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSettingsQuery = { __typename?: 'Query', appSettings?: Array<{ __typename?: 'AppSetting', value: string, id: string }> | null };

export type GetBuildingQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBuildingQuery = { __typename?: 'Query', getBuilding?: { __typename?: 'Building', id: string, name?: string | null, address?: string | null, propertyManagerEmail?: string | null, propertyManagerPhone?: string | null, propertyManagerCompany?: string | null, settings?: string | null } | null };

export type GetCheckOnMeContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckOnMeContactsQuery = { __typename?: 'Query', getCheckOnMeContacts: Array<{ __typename?: 'CheckOnMeContact', id: string, name: string, email: string, phone: string, status: CheckOnMeContactStatus, confirmedAt?: string | null, createdAt: string }> };

export type AddCheckOnMeContactMutationVariables = Exact<{
  input: AddCheckOnMeContactInput;
}>;


export type AddCheckOnMeContactMutation = { __typename?: 'Mutation', addCheckOnMeContact: AddCheckOnMeContactResult };

export type EditCheckOnMeContactMutationVariables = Exact<{
  input: EditCheckOnMeContactInput;
}>;


export type EditCheckOnMeContactMutation = { __typename?: 'Mutation', editCheckOnMeContact: EditCheckOnMeContactResult };

export type RemoveCheckOnMeContactMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type RemoveCheckOnMeContactMutation = { __typename?: 'Mutation', removeCheckOnMeContact: RemoveCheckOnMeContactResult };

export type ResendCheckOnMeContactConfirmationMutationVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type ResendCheckOnMeContactConfirmationMutation = { __typename?: 'Mutation', resendCheckOnMeContactConfirmation: ResendCheckOnMeContactConfirmationResult };

export type GetExperimentalFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExperimentalFeaturesQuery = { __typename?: 'Query', getExperimentalFeatures?: Array<{ __typename?: 'ExperimentalFeature', id: string, name: string, description?: string | null, enabled: boolean, sortOrder: number }> | null };

export type NearestScheduledMoveInQueryVariables = Exact<{ [key: string]: never; }>;


export type NearestScheduledMoveInQuery = { __typename?: 'Query', nearestScheduledMoveIn?: { __typename?: 'NearestScheduledMoveIn', date?: any | null } | null };

export type NearestScheduledMoveOutQueryVariables = Exact<{ [key: string]: never; }>;


export type NearestScheduledMoveOutQuery = { __typename?: 'Query', nearestScheduledMoveOut?: { __typename?: 'NearestScheduledMoveOut', date?: any | null } | null };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', createdAt: any, homeAssistantEventId?: string | null, id: string, importance: NotificationImportance, status: NotificationStatus, text: string, title?: string | null }> | null };

export type NotificationPageQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type NotificationPageQuery = { __typename?: 'Query', notifications?: Array<{ __typename?: 'Notification', createdAt: any, homeAssistantEventId?: string | null, id: string, importance: NotificationImportance, status: NotificationStatus, text: string, title?: string | null }> | null };

export type UpdateNotificationMutationVariables = Exact<{
  input: UpdateNotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: UpdateNotificationResult };

export type UpdateAllNotificationsMutationVariables = Exact<{
  input: UpdateAllNotificationsInput;
}>;


export type UpdateAllNotificationsMutation = { __typename?: 'Mutation', updateAllNotifications: UpdateAllNotificationsResult };

export type GetBuildingSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuildingSettingsQuery = { __typename?: 'Query', getBuildingSettings?: string | null };

export type GetUnitSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitSettingsQuery = { __typename?: 'Query', getUnitSettings?: string | null };

export type GetResidentSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResidentSettingsQuery = { __typename?: 'Query', getResidentSettings?: string | null };

export type SetShowerAlertMutationVariables = Exact<{
  input: SetShowerAlertInput;
}>;


export type SetShowerAlertMutation = { __typename?: 'Mutation', setShowerAlert: SetShowerAlertResult };

export type SetShowerAlertTimeMutationVariables = Exact<{
  input: SetShowerAlertTimeInput;
}>;


export type SetShowerAlertTimeMutation = { __typename?: 'Mutation', setShowerAlertTime: SetShowerAlertTimeResult };

export type SetShowerFanAutoOnMutationVariables = Exact<{
  input: SetShowerFanAutoOnInput;
}>;


export type SetShowerFanAutoOnMutation = { __typename?: 'Mutation', setShowerFanAutoOn: SetShowerFanAutoOnResult };

export type GetUserBuildingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserBuildingQuery = { __typename?: 'Query', getUserBuilding?: { __typename?: 'Building', id: string, name?: string | null, address?: string | null, buildingCode?: string | null, propertyManagerEmail?: string | null, propertyManagerPhone?: string | null, propertyManagerCompany?: string | null, latitude?: number | null, longitude?: number | null, settings?: string | null, unit?: { __typename?: 'Unit', id: string, name?: string | null, floor?: string | null, unitNumber?: string | null, bedrooms?: number | null, bathrooms?: number | null } | null } | null };

export type NotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationSettingsQuery = { __typename?: 'Query', userSettings: { __typename?: 'UserSettings', syncClimate: boolean, checkOnMeEnabled: boolean, notificationSettings: { __typename?: 'NotificationSettings', criticalLevelNotificationChannels: Array<NotificationChannel>, mediumLevelNotificationChannels: Array<NotificationChannel>, lowLevelNotificationChannels: Array<NotificationChannel>, muteNotifications: boolean, energyConsumptionNotifications: boolean } } };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: UpdateUserSettingsResult };

export type RemindPinMutationVariables = Exact<{ [key: string]: never; }>;


export type RemindPinMutation = { __typename?: 'Mutation', remindUserApplicationPin: RemindUserApplicationPinResult };

export type RemoveUserApartmentPinionMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveUserApartmentPinionMutation = { __typename?: 'Mutation', removeUserApartmentPin: RemoveUserAppartmentPinResult };

export type SetUserApartmentPinMutationVariables = Exact<{
  input: SetUserApartmentPinInput;
}>;


export type SetUserApartmentPinMutation = { __typename?: 'Mutation', setUserApartmentPin: SetUserApartmentPinResult };

export type AddUserTokenMutationVariables = Exact<{
  input: AddUserTokenInput;
}>;


export type AddUserTokenMutation = { __typename?: 'Mutation', addUserToken: AddUserTokenResult };

export type UpdateUserLastLoginMutationVariables = Exact<{
  input: UpdateUserLastLoginInput;
}>;


export type UpdateUserLastLoginMutation = { __typename?: 'Mutation', updateUserLastLogin: UpdateUserSettingsResult };

export const SubmitEarlyAccessFeedbackDocument = gql`
    mutation SubmitEarlyAccessFeedback($input: SubmitEarlyAccessFeedbackInput!) {
  submitEarlyAccessFeedback(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitEarlyAccessFeedbackGQL extends Apollo.Mutation<SubmitEarlyAccessFeedbackMutation, SubmitEarlyAccessFeedbackMutationVariables> {
    document = SubmitEarlyAccessFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBuildingSettingsDocument = gql`
    mutation UpdateBuildingSettings($input: UpdateBuildingSettingsInput!) {
  updateBuildingSettings(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBuildingSettingsGQL extends Apollo.Mutation<UpdateBuildingSettingsMutation, UpdateBuildingSettingsMutationVariables> {
    document = UpdateBuildingSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUnitSettingsDocument = gql`
    mutation UpdateUnitSettings($input: UpdateUnitSettingsInput!) {
  updateUnitSettings(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnitSettingsGQL extends Apollo.Mutation<UpdateUnitSettingsMutation, UpdateUnitSettingsMutationVariables> {
    document = UpdateUnitSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateResidentSettingsDocument = gql`
    mutation UpdateResidentSettings($input: UpdateResidentSettingsInput!) {
  updateResidentSettings(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateResidentSettingsGQL extends Apollo.Mutation<UpdateResidentSettingsMutation, UpdateResidentSettingsMutationVariables> {
    document = UpdateResidentSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AppSettingsDocument = gql`
    query AppSettings {
  appSettings {
    value
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AppSettingsGQL extends Apollo.Query<AppSettingsQuery, AppSettingsQueryVariables> {
    document = AppSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBuildingDocument = gql`
    query GetBuilding($id: String!) {
  getBuilding(id: $id) {
    id
    name
    address
    propertyManagerEmail
    propertyManagerPhone
    propertyManagerCompany
    settings
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBuildingGQL extends Apollo.Query<GetBuildingQuery, GetBuildingQueryVariables> {
    document = GetBuildingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCheckOnMeContactsDocument = gql`
    query GetCheckOnMeContacts {
  getCheckOnMeContacts {
    id
    name
    email
    phone
    status
    confirmedAt
    createdAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCheckOnMeContactsGQL extends Apollo.Query<GetCheckOnMeContactsQuery, GetCheckOnMeContactsQueryVariables> {
    document = GetCheckOnMeContactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCheckOnMeContactDocument = gql`
    mutation AddCheckOnMeContact($input: AddCheckOnMeContactInput!) {
  addCheckOnMeContact(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCheckOnMeContactGQL extends Apollo.Mutation<AddCheckOnMeContactMutation, AddCheckOnMeContactMutationVariables> {
    document = AddCheckOnMeContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditCheckOnMeContactDocument = gql`
    mutation EditCheckOnMeContact($input: EditCheckOnMeContactInput!) {
  editCheckOnMeContact(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditCheckOnMeContactGQL extends Apollo.Mutation<EditCheckOnMeContactMutation, EditCheckOnMeContactMutationVariables> {
    document = EditCheckOnMeContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCheckOnMeContactDocument = gql`
    mutation RemoveCheckOnMeContact($contactId: String!) {
  removeCheckOnMeContact(contactId: $contactId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCheckOnMeContactGQL extends Apollo.Mutation<RemoveCheckOnMeContactMutation, RemoveCheckOnMeContactMutationVariables> {
    document = RemoveCheckOnMeContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendCheckOnMeContactConfirmationDocument = gql`
    mutation ResendCheckOnMeContactConfirmation($contactId: String!) {
  resendCheckOnMeContactConfirmation(contactId: $contactId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendCheckOnMeContactConfirmationGQL extends Apollo.Mutation<ResendCheckOnMeContactConfirmationMutation, ResendCheckOnMeContactConfirmationMutationVariables> {
    document = ResendCheckOnMeContactConfirmationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExperimentalFeaturesDocument = gql`
    query GetExperimentalFeatures {
  getExperimentalFeatures {
    id
    name
    description
    enabled
    sortOrder
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExperimentalFeaturesGQL extends Apollo.Query<GetExperimentalFeaturesQuery, GetExperimentalFeaturesQueryVariables> {
    document = GetExperimentalFeaturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NearestScheduledMoveInDocument = gql`
    query NearestScheduledMoveIn {
  nearestScheduledMoveIn {
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NearestScheduledMoveInGQL extends Apollo.Query<NearestScheduledMoveInQuery, NearestScheduledMoveInQueryVariables> {
    document = NearestScheduledMoveInDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NearestScheduledMoveOutDocument = gql`
    query NearestScheduledMoveOut {
  nearestScheduledMoveOut {
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NearestScheduledMoveOutGQL extends Apollo.Query<NearestScheduledMoveOutQuery, NearestScheduledMoveOutQueryVariables> {
    document = NearestScheduledMoveOutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationsDocument = gql`
    query Notifications {
  notifications {
    createdAt
    homeAssistantEventId
    id
    importance
    status
    text
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationsGQL extends Apollo.Query<NotificationsQuery, NotificationsQueryVariables> {
    document = NotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationPageDocument = gql`
    query NotificationPage($pagination: PaginationInput) {
  notifications(pagination: $pagination) {
    createdAt
    homeAssistantEventId
    id
    importance
    status
    text
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationPageGQL extends Apollo.Query<NotificationPageQuery, NotificationPageQueryVariables> {
    document = NotificationPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNotificationDocument = gql`
    mutation UpdateNotification($input: UpdateNotificationInput!) {
  updateNotification(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNotificationGQL extends Apollo.Mutation<UpdateNotificationMutation, UpdateNotificationMutationVariables> {
    document = UpdateNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAllNotificationsDocument = gql`
    mutation UpdateAllNotifications($input: UpdateAllNotificationsInput!) {
  updateAllNotifications(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAllNotificationsGQL extends Apollo.Mutation<UpdateAllNotificationsMutation, UpdateAllNotificationsMutationVariables> {
    document = UpdateAllNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBuildingSettingsDocument = gql`
    query GetBuildingSettings {
  getBuildingSettings
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBuildingSettingsGQL extends Apollo.Query<GetBuildingSettingsQuery, GetBuildingSettingsQueryVariables> {
    document = GetBuildingSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnitSettingsDocument = gql`
    query GetUnitSettings {
  getUnitSettings
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitSettingsGQL extends Apollo.Query<GetUnitSettingsQuery, GetUnitSettingsQueryVariables> {
    document = GetUnitSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetResidentSettingsDocument = gql`
    query GetResidentSettings {
  getResidentSettings
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetResidentSettingsGQL extends Apollo.Query<GetResidentSettingsQuery, GetResidentSettingsQueryVariables> {
    document = GetResidentSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetShowerAlertDocument = gql`
    mutation SetShowerAlert($input: SetShowerAlertInput!) {
  setShowerAlert(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetShowerAlertGQL extends Apollo.Mutation<SetShowerAlertMutation, SetShowerAlertMutationVariables> {
    document = SetShowerAlertDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetShowerAlertTimeDocument = gql`
    mutation SetShowerAlertTime($input: SetShowerAlertTimeInput!) {
  setShowerAlertTime(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetShowerAlertTimeGQL extends Apollo.Mutation<SetShowerAlertTimeMutation, SetShowerAlertTimeMutationVariables> {
    document = SetShowerAlertTimeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetShowerFanAutoOnDocument = gql`
    mutation SetShowerFanAutoOn($input: SetShowerFanAutoOnInput!) {
  setShowerFanAutoOn(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetShowerFanAutoOnGQL extends Apollo.Mutation<SetShowerFanAutoOnMutation, SetShowerFanAutoOnMutationVariables> {
    document = SetShowerFanAutoOnDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserBuildingDocument = gql`
    query GetUserBuilding {
  getUserBuilding {
    id
    name
    address
    buildingCode
    propertyManagerEmail
    propertyManagerPhone
    propertyManagerCompany
    latitude
    longitude
    settings
    unit {
      id
      name
      floor
      unitNumber
      bedrooms
      bathrooms
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserBuildingGQL extends Apollo.Query<GetUserBuildingQuery, GetUserBuildingQueryVariables> {
    document = GetUserBuildingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationSettingsDocument = gql`
    query NotificationSettings {
  userSettings {
    notificationSettings {
      criticalLevelNotificationChannels
      mediumLevelNotificationChannels
      lowLevelNotificationChannels
      muteNotifications
      energyConsumptionNotifications
    }
    syncClimate
    checkOnMeEnabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationSettingsGQL extends Apollo.Query<NotificationSettingsQuery, NotificationSettingsQueryVariables> {
    document = NotificationSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
  updateUserSettings(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserSettingsGQL extends Apollo.Mutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables> {
    document = UpdateUserSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemindPinDocument = gql`
    mutation RemindPin {
  remindUserApplicationPin
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemindPinGQL extends Apollo.Mutation<RemindPinMutation, RemindPinMutationVariables> {
    document = RemindPinDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserApartmentPinionDocument = gql`
    mutation RemoveUserApartmentPinion {
  removeUserApartmentPin
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserApartmentPinionGQL extends Apollo.Mutation<RemoveUserApartmentPinionMutation, RemoveUserApartmentPinionMutationVariables> {
    document = RemoveUserApartmentPinionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetUserApartmentPinDocument = gql`
    mutation SetUserApartmentPin($input: SetUserApartmentPinInput!) {
  setUserApartmentPin(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetUserApartmentPinGQL extends Apollo.Mutation<SetUserApartmentPinMutation, SetUserApartmentPinMutationVariables> {
    document = SetUserApartmentPinDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddUserTokenDocument = gql`
    mutation AddUserToken($input: AddUserTokenInput!) {
  addUserToken(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserTokenGQL extends Apollo.Mutation<AddUserTokenMutation, AddUserTokenMutationVariables> {
    document = AddUserTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserLastLoginDocument = gql`
    mutation UpdateUserLastLogin($input: UpdateUserLastLoginInput!) {
  updateUserLastLogin(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserLastLoginGQL extends Apollo.Mutation<UpdateUserLastLoginMutation, UpdateUserLastLoginMutationVariables> {
    document = UpdateUserLastLoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }